import React from 'react';

const TermsConditions = ({ value, onChange, isEditable }) => {
  // Split text into lines
  const termsList = value ? value.split(/\n+/) : [];

  return (
    <div className="terms-conditions">
      <h4>Terms & Conditions</h4>
      {isEditable ? (
        <textarea
          value={value}
          onChange={onChange}
          rows={6}
          style={{ width: "100%" }}
        />
      ) : (
        <ol style={{ paddingLeft: "20px" }}>
          {termsList.map((term, idx) => (
            <li key={idx}>{term.replace(/^\d+\.\s*/, '')}</li>
          ))}
        </ol>
      )}
    </div>
  );
};

export default TermsConditions;
;


// const TermsConditions = () => {
//   return (
//     <div className="terms">
//       <p><strong>Terms & Conditions</strong></p>
//       <ul>
//       <li>All packages are non-customizable and apply uniformly to all clients.</li>
//             <li>Once payment is processed, it is non-refundable.</li>
//             <li>VidyutCloud exclusively provides leads and does not engage in transactions, shipping, or any other activities beyond lead generation.</li>
//             <li>The volume of leads is subject to market conditions and may fluctuate accordingly.</li>
//             <li>Vendor sourcing and digital marketing services are available exclusively in the Advanced Package.</li>
//             <li>Digital marketing includes 3 months of advertisement on VidyutCloud's homepage (banner service) and one social media post per month for 1 year to promote festivals.</li>
//       </ul>
//     </div>
//   );
// };

// export default TermsConditions;